import React, { useState, useMemo, useEffect } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField,
    InputAdornment,
    Chip,
    Checkbox
} from "@mui/material"
import { KeyboardArrowDown, Search } from "@mui/icons-material"
import { sxSelect, sxMenuPaper, sxChipSelect, sxBoxRenderValue } from "./SxUsuarioSelect"

const Teste = (obj, searchText) => {
    const option = obj.nome.toLowerCase()
    return option.indexOf(searchText.toLowerCase()) > -1
}

const UsuarioSelect = ({ name, options, label = "nome", value = "id", callback, required, defaultValue, ...rest }) => {
    const [searchText, setSearchText] = useState("")
    const displayedOptions = useMemo(
        () => options.filter((option) => Teste(option, searchText)),
        [searchText]
    )

    const [initialized, setInitialized] = useState(false)

    const [selected, setSelected] = useState(defaultValue ? options.filter(usuario => defaultValue.find(ev => usuario.id == ev.id)) : [])

    const handleChange = (event) => {
        setSelected(event.target.value)
    }

    useEffect(() => {
        if (initialized) {
            callback(selected)
        } else {
            setInitialized(true)
        }
    }, [selected])

    return (
        <Box >
            {options &&
            <FormControl sx={{ width: '100%', color: 'black' }}>
                {/* <Typography id="search-select-label">Revenda</Typography> */}
                <Select
                    name={name}
                    multiple
                    sx={sxSelect}
                    value={selected}
                    onChange={handleChange}
                    renderValue={(selected) => (
                        <Box sx={sxBoxRenderValue} display="flex" flexWrap="wrap">
                            {selected.map((value, index) => (
                                <Chip
                                    sx={sxChipSelect}
                                    key={index}
                                    label={value[label]}
                                />
                            ))}
                        </Box>
                    )}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: { sx: sxMenuPaper },
                        sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                    }} // Disables auto focus on MenuItems and allows TextField to be in focus
                    inputProps={{
                        sx: { padding: '0 5px' }
                    }}
                    labelId="search-select-label"
                    IconComponent={KeyboardArrowDown}
                    id="navbar_revenda_select"
                    // onChange={(e) => setSelectedOption(e.target.value)}
                    onClose={() => setSearchText("")}
                    // This prevents rendering empty string in Select's value
                    // if search text would exclude currently selected option.
                    // renderValue={() => options.nome}
                    {...rest}
                >
                    {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection. */}
                    <ListSubheader>
                        <TextField
                            size="small"
                            // Autofocus on textfield
                            autoFocus
                            placeholder="Pesquisar..."
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation()
                                }
                            }}
                        />
                    </ListSubheader>
                    <MenuItem key={`menu_combo_vazio`} value="">
                            Nenhuma opção
                    </MenuItem>
                    {displayedOptions.map((option, i) => (
                        <MenuItem sx={{ height: '30px' }} key={`menu_combo_${i}`} value={option}>
                            <Checkbox checked={selected.some(element => element.id == option.id)} />
                            {option[label]}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            }
        </Box>
    )
}

export default UsuarioSelect
